var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-page',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('render-content',{attrs:{"id":"thankyou"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }